import { useEffect, useState } from 'react';

const LearnwiseChat = ({ name, email }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Expose functions globally for ChatbotSelector
    window.learnwiseChat = {
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen(prev => !prev),
      isOpen: () => isOpen
    };

    return () => {
      delete window.learnwiseChat;
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    // Create iframe when opened
    let iframe = document.getElementById('learnwise-chat');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'learnwise-chat';
      iframe.src = `${process.env.REACT_APP_LEARNWISE_CHATBOT_URL}&isolatedIframe=true&userName=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`;
      iframe.style.cssText = 'position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100vw !important; height: 100vh !important; border: none !important; z-index: 9999 !important;';
      document.body.appendChild(iframe);
    } else {
      iframe.style.display = 'block';
    }

    return () => {
      if (iframe) iframe.style.display = 'none';
    };
  }, [isOpen]);

  return null;
};

export default LearnwiseChat;
